import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import BackButton from '../../../../components/shared/BackButton/BackButton';
import { fetchImportHistory, removeImportHistory } from '../../../../redux/actions/networkActions';
import urls from '../../../../routing/urls';

import ImportHistoryDetails from './ImportHistoryDetails';

import styles from './ImportHistory.module.scss';

const ImportHistory = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const location = useLocation();
  const [importHistoryRef, setImportHistoryRef] = useState(null);

  const csvImportHistory = useSelector((state) => state.networkReducer.csvImportHistory);

  const getCSVImportHistory = useCallback((source) => {
    dispatch(fetchImportHistory(source));
  }, []);

  const deleteCSVImportHistory = useCallback((id) => {
    dispatch(removeImportHistory(id));
  }, []);

  const onDelete = useCallback((id) => {
    deleteCSVImportHistory(id);
  }, []);

  const getHistory = useCallback(() => {
    if (urls.csvImportHistory === location.pathname) {
      getCSVImportHistory('csv');
    }
    if (urls.linkedinImportHistory === location.pathname) {
      getCSVImportHistory('linkedin');
    }
  }, [location]);

  useEffect(() => {
    getHistory();

    const historyRef = setInterval(() => {
      getHistory();
    }, [5000]);

    setImportHistoryRef(historyRef);

    return () => {
      clearInterval(historyRef);
    };
  }, [location]);

  useEffect(() => {
    if (csvImportHistory.length > 0 && importHistoryRef) {
      const inProcessHistory = csvImportHistory.find((csvHistory) => csvHistory.status === 'processing');
      if (!inProcessHistory && importHistoryRef) {
        clearInterval(importHistoryRef);
      }
    }
  }, [csvImportHistory, importHistoryRef]);

  return (
    <div className={styles.rootCont}>
      <div className={styles.backCont}>
        <BackButton />
      </div>
      <div className={styles.sectionCont}>
        <p className={styles.heading}>{t('csvImport.pastImports')}</p>
        {csvImportHistory.length > 0 && <ImportHistoryDetails data={csvImportHistory} onDelete={onDelete} />}
      </div>
    </div>
  );
};

export default ImportHistory;
